export const getQueryString = () => {
  const value = new URLSearchParams(window.location.search);
  return value;
};

/**
 * payload to query-string
 * @param {*} payload
 * @returns
 */
export const toQueryString = (payload) => {
  return Object.entries(payload)
    .map((e) => e.join('='))
    .join('&');
};

/**
 * query-string to payload
 * @param {*} query_string
 * @returns
 */
export const toPayload = (queryStr) => {
  if (!queryStr) return '';
  return Object.fromEntries(
    queryStr
      .replace('?', '')
      .split('&')
      .map((x) => x.split('='))
  );
};
